import constants from "../constants.js";

const EndDate = {
  displayName: 'End date',
  dataAt: "EndDate",
  displayAs: constants.DISPLAY_AS.DATE_PICKER,
  disabled: true,
  returnAsString: true,
  minDateAt: "StartDate"
};
const StartDate = {
  displayName: 'Start date',
  dataAt: "StartDate",
  displayAs: constants.DISPLAY_AS.DATE_PICKER,
  disabled: true,
  returnAsString: true,
  maxDateAt: "EndDate",
};

const CampaignModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CampaignModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CampaignCreatedOn = {
  displayName: 'Created On',
  dataAt: 'CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CampaignCreatedBy = {
  displayName: 'Created By',
  dataAt: 'CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CampaignEnabled = {
  displayName: "Enabled",
  dataAt: "Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CampaignDebtors = {
  displayName: "Debtor(s)",
  dataAt: "Debtors",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Debtors",
  searchType: "Title",
  expression: "contains",
  inputTitle: "Title",
  selectChoiceName: "Title",
  entityIdentifier: "Name",
  searchAllNo: true,
  isMultiSelect: true,
  includeDisabled: false,
  includeOptions: [{ 
    Id: "*",
    Title: "All Debtors",
    TitleInSearch: "*Apply to All Debtors",
    IsIncludeOption: true
  }],
  includeOptionsPropertyToSave: "Id",
  dataSelectPropertyToCheck: ""
};

const CampaignRules = {
  displayName: "Rule(s)",
  dataAt: "Rules",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "VendorPreferenceConfigRules",
  searchType: "RuleName",
  expression: "contains",
  inputTitle: "RuleName",
  selectChoiceName: "RuleName",
  searchAllNo: true,
  isMultiSelect: true,
  includeDisabled: false,
  filterUsingEnabled: true
};

const CampaignDescription = {
  displayName: "Description",
  dataAt: "CampaignDescription",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
}

const CampaignName = {
  displayName: "Name",
  dataAt: "CampaignName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
}

const RuleEnabled = {
  displayName: "Enabled",
  dataAt: "Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const Priority = {
  displayName: "Priority",
  dataAt: "Priority",
  displayAs: constants.DISPLAY_AS.SELECT,
  rangeValuesAt: "VendorPreferenceRangeValues",
  showRangeValuesReverseOrder: true,
  optionsNumbers: true,
}

const HotelIDs = {
  displayName: "Hotel IDs",
  dataAt: "HotelIDs",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelChainCodes = {
  displayName: "Hotel master chain code(s)",
  dataAt: "HotelChainCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const RuleDescription = {
  displayName: "Rule description",
  dataAt: "Description",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
}

const RuleName = {
  displayName: "Rule name",
  dataAt: "RuleName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
}

const AirPrefWeight = {
  displayName: "Weight",
  dataAt: "AirPref.AirPrefWeight",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 100,
  step: 1,
  defaultValue: 0,
  units: "Units",
  helpText: "When multiple rules are found to be applied the higher weighted rule will be used."
}

const RuleProductType = {
  displayName: "Product Type",
  dataAt: "ProductType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "VenderPrefRuleProductType"
}

const AirPrefAirlinesPriority = {
  displayName: "Priority Airlines",
  dataAt: "AirPref.AirlinesPrioritized",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AirPrefAirlinesExcluded = {
  displayName: "Airlines Excluded",
  dataAt: "AirPref.AirlinesExcluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AirPrefRtPairOriginCountries = {
  displayName: "Origin Countries",
  dataAt: "AirPref.RoutingPairs.$rtPairItemId.OriginCountries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
const AirPrefRtPairOriginAirportCodes = {
  displayName: "Origin Airport Codes",
  dataAt: "AirPref.RoutingPairs.$rtPairItemId.OriginAirportCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
const AirPrefRtPairDestinationCountries = {
  displayName: "Destination Countries",
  dataAt: "AirPref.RoutingPairs.$rtPairItemId.DestinationCountries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
const AirPrefRtPairDestinationAirportCodes = {
  displayName: "Destination Airport Codes",
  dataAt: "AirPref.RoutingPairs.$rtPairItemId.DestinationAirportCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};
const AirPrefRtPairItem = {
  displayName: "Routing Pair Item",
  dataAt: "AirPref.RoutingPairs.$rtPairItemId",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirPrefRtPairOriginCountries, AirPrefRtPairOriginAirportCodes,AirPrefRtPairDestinationCountries,AirPrefRtPairDestinationAirportCodes],
  endpoint: "VendorPreferenceConfigRules",
  removeParamId: "rtPairItemId",
  canDelete: true,
  routeParamId: "rRulesItem"
};
const AirPrefRtPairs = {
  displayName: "Routing Pairs",
  dataAt: "AirPref.RoutingPairs",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirPrefRtPairItem,
  gridCols: [
    { name: "OriginCountries", key: "OriginCountries" },
    { name: "OriginAirportCodes", key: "OriginAirportCodes" },
    { name: "DestinationCountries", key: "DestinationCountries" },
    { name: "DestinationAirportCodes", key: "DestinationAirportCodes" }
  ],
};

const AirPrefThresholdMinutesPlus = {
  displayName: "Threshold Plus Minutes",
  dataAt: "AirPref.ThresholdMinutesPlus",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 1000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};

const AirPrefThresholdMinutesMinues = {
  displayName: "Threshold Minues Minutes",
  dataAt: "AirPref.ThresholdMinutesMinus",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 1000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};

const AirPrefStopPriority = {
  displayName: "Stop Priority",
  dataAt: "AirPref.StopPriority",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "VenderPrefAirPrefStopPriority"
}

const AirPrefSortOrder = {
  displayName: "Sort Order",
  dataAt: "AirPref.SortOrder",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "VenderPrefAirPrefSortingType"
}

const RulesGridItem = {
  displayName: "Item",
  dataAt: "Rules",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    RuleProductType,
    RuleName,
    RuleDescription,
    HotelChainCodes,
    HotelIDs,
    Priority,
    RuleEnabled
  ],
  endpoint: "VendorPreferenceConfigRules",
  routeParamId: "rRulesItem",
  deleteOnBackend: true,
  canDelete: true
};

const RulesGridFlightItem = {
  displayName: "Item",
  dataAt: "Rules",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    RuleEnabled,
    
    RuleName,
    RuleDescription,
    RuleProductType,
    AirPrefWeight,
    AirPrefSortOrder,
    AirPrefAirlinesPriority,AirPrefAirlinesExcluded,AirPrefThresholdMinutesPlus,AirPrefThresholdMinutesMinues,AirPrefStopPriority,
    AirPrefRtPairs
  ],
  endpoint: "VendorPreferenceConfigRules",
  routeParamId: "rRulesItem",
  deleteOnBackend: true,
  canDelete: true
};

const RulesGridItemAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Rules",
  data: { RuleName: ""},
  dataAt: "",
  children: [RuleName,RuleProductType],
  endpoint: "VendorPreferenceConfigRules",
  continueEditPath: getRulePath
};

export function getRulePath(data){
  let displayNamePathReady = getRulePathRoute(data)
  return'/vendor-preference-configs/rules/' + displayNamePathReady + data.Id;
}
export function getRulePathRoute(data) {
  switch (data.ProductType) {
    case "Flight":
      return 'flight/';
    case "Hotel":
    default:
      return '';
  }
};

const RulesGrid = {
    rootNode: true,
    displayName: "Rules",
    nameFieldName: "RuleName",
    endpoint: "VendorPreferenceConfigRules",
    displayAs: constants.DISPLAY_AS.GRID,
    canCopyResource: true,
    canAddNew: true,
    gridItem: RulesGridItem,
    gridAdd: RulesGridItemAddResource,
    canFilterDisabled: true,
    disableProperty: "Enabled",
    filterUsingEnabled: true,
    gridCols: [
      { name: "Product", key: "ProductType" },
      { name: "Rule Name", key: "RuleName" },
      { name: "Description", key: "Description" },
      { name: "Enabled", key: "Enabled" },
      { name: "Rule Details", key: "RuleDesc",colWidth:"300" },
      
    ],
    pathSwitcher: getRulePathRoute,
  };

const CampaignsGridItem = {
  displayName: "Item",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CampaignName,
    CampaignDescription,
    StartDate,
    EndDate,
    CampaignRules,
    CampaignDebtors,
    CampaignEnabled,
    CampaignCreatedBy,
    CampaignCreatedOn,
    CampaignModifiedBy,
    CampaignModifiedOn
  ],
  endpoint: "VendorPreferenceConfigCampaigns",
  routeParamId: "cCampaignsItem",
  deleteOnBackend: true,
  canDelete: true
};

const CampaignsGridItemAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Campaign",
  data: { CampaignName: ""},
  dataAt: "",
  children: [CampaignName],
  endpoint: "VendorPreferenceConfigCampaigns",
};

const CampaignsGrid = {
  rootNode: true,
  displayName: "Campaigns",
  nameFieldName: "CampaignName",
  endpoint: "CampaignsEager",
  copyResourceEndpoint: "VendorPreferenceConfigCampaigns",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyResource: true,
  canAddNew: true,
  gridItem: CampaignsGridItem,
  gridAdd: CampaignsGridItemAddResource,
  canFilterDisabled: true,
  disableProperty: "Enabled",
  filterUsingEnabled: true,
  isRestEndpoint: true,
  gridCols: [
    { name: "Name", key: "CampaignName" },
    { name: "Description", key: "CampaignDescription" },
    { name: "Start date", key: "StartDate" },
    { name: "End date", key: "EndDate" },
    { name: "Rule name", key: "Rules" },
    { name: "Debtor", key: "Debtors" },
    { name: "Enabled", key: "Enabled" },
  ],
};

const CampaignsTab = {
  tabName: "Campaigns",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    CampaignsGrid
  ],
};

const RulesTab = {
  tabName: "Rules",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    RulesGrid
  ],
};

const VendorPreferenceConfigsTab = {
  displayName: "Vendor",
  iconClass: "fa-cog",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    CampaignsTab,
    RulesTab
  ],
};

const VendorPreferenceConfigs = {
  rootNode: true,
  displayName: "Vendor Preference Config",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: "fa-cog",
  dataAt: "",
  endpoint: "VendorPreferenceConfigCampaigns",
  children: [VendorPreferenceConfigsTab],
  hideSave: true,
};

export default {
  VendorPreferenceConfigs,
  VendorPreferenceConfigsTab,
  RulesTab,
  CampaignsTab,
  CampaignsGrid,
  CampaignsGridItem,
  CampaignsGridItemAddResource,
  RulesGrid,
  RulesGridItem,
  RulesGridItemAddResource,
  RuleName,
  RuleDescription,
  HotelChainCodes,
  Priority,
  RuleEnabled,
  CampaignName,
  CampaignDescription,
  StartDate,
  EndDate,
  CampaignRules,
  CampaignDebtors,
  CampaignEnabled,
  CampaignCreatedBy,
  CampaignCreatedOn,
  CampaignModifiedBy,
  CampaignModifiedOn,
  RuleProductType,
  RulesGridFlightItem,
  AirPrefRtPairItem
};


// WEBPACK FOOTER //
// ./src/config/fields/vendorPreferenceConfigs.js